import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useEpisode } from "../../../contexts/EpisodeContext";
import useGraphqlService from "../../../util/useGraphqlService";
import { CREATE_ENTRY_MUTATION } from "../../../constants/graphql/entryQueries";

const EntryForm = ({ initialUUID, onEntryCreated }) => {
    const [form] = Form.useForm();
    const { episode } = useEpisode();
    const { sendGraphqlRequest, loading } = useGraphqlService();

    const handleSubmit = async (values) => {
        try {
            const payload = {
                episodeId: parseInt(values.episodeId),
                paperName: values.paperName,
                paperUuid: values.paperUuid
            }
            const data = await sendGraphqlRequest(CREATE_ENTRY_MUTATION, { input: payload });
            message.success('Entry successfully created!');
            console.log('Created Entry:', data.createEntry);
            form.resetFields();  // Optionally reset the form fields
            onEntryCreated(data.createEntry);
        } catch (error) {
            message.error('Failed to create entry. ' + error.message);
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleSubmit} initialValues={{ episodeId: episode?.id, paperUuid: initialUUID }}>
            <Form.Item name="episodeId" label="episodeId" hidden>
                <Input />
            </Form.Item>
            <Form.Item name="paperUuid" label="paperUuid" hidden>
                <Input />
            </Form.Item>
            <Form.Item
                name="paperName"
                label="Name on Paper"
                rules={[{ required: true, message: 'Paper Name is required' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Create Entry
                </Button>
            </Form.Item>
            <div style={{ marginTop: '20px', color: '#1890ff' }}>
                <InfoCircleOutlined style={{ marginRight: '8px' }} />
                Feature Notice: We could easily add phone number capture to allow sending an SMS message to a comedian when their name is pulled.
            </div>
        </Form>
    );
};

export default EntryForm;